import { render, staticRenderFns } from "./dietitian.vue?vue&type=template&id=2fbf44b3"
import script from "./dietitian.vue?vue&type=script&lang=js"
export * from "./dietitian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports